type UStr<P extends string, N extends string> = `${P}${N}`
type RutaCompras<T extends string> = `compras-${T}`

const prefixer = <T extends string>(v: T): RutaCompras<T> => {
    return `compras-${v}`
}

export const prefixerM = <T extends string>(v: T): RutaCompras<UStr<'mantenimiento-', typeof v>> =>
    prefixer(`mantenimiento-${v}`) as RutaCompras<UStr<'mantenimiento-', typeof v>>

export const prefixerT = <T extends string>(v: T): RutaCompras<UStr<'transacciones-', typeof v>> =>
    prefixer(`transacciones-${v}`) as RutaCompras<UStr<'transacciones-', typeof v>>

export const prefixerC = <T extends string>(v: T): RutaCompras<UStr<'configuracion-', typeof v>> =>
    prefixer(`configuracion-${v}`) as RutaCompras<UStr<'configuracion-', typeof v>>

export const prefixerI = <T extends string>(v: T): RutaCompras<UStr<'informes-', typeof v>> =>
    prefixer(`informes-${v}`) as RutaCompras<UStr<'informes-', typeof v>>
